import { FormattedMessage } from 'react-intl';
import { Button } from '../Button';
import { Fragment, useState } from 'react';
import { Website } from 'src/orchd-client';
import { UploadSystem } from './UploadSystem';

interface Props {
  uploadUrl: string;
  website: Website;
}

export const UploadButton = ({ uploadUrl, website }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <Fragment>
      {modalOpen && <UploadSystem uploadUrl={uploadUrl} website={website} setModalOpen={setModalOpen} />}
      <Button size="small" onClick={() => setModalOpen(true)}>
        <FormattedMessage id="backups.upload" defaultMessage="Upload backup" />
      </Button>
    </Fragment>
  );
};
